module.exports = __webpack_public_path__ + "img/icon-22.85e30803.svg";